import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './layouts/Layout';
import Home from './pages/Home';
import Sobre from './pages/Sobre';
import Dizimos from './pages/Dizimos';
import Ministerios from './pages/Ministerios';
import Agenda from './pages/Agenda';
import Contato from './pages/Contato';
import Palavras from './pages/Palavras';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/sobre" element={<Sobre />} />
          <Route path="/dizimos" element={<Dizimos />} />
          <Route path="/ministerios" element={<Ministerios />} />
          <Route path="/agenda" element={<Agenda />} />
          <Route path="/palavras" element={<Palavras />} />
          <Route path="/contato" element={<Contato />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
